module.exports = __webpack_public_path__ + "media/img/illustrations/toastr-info-baeae600c6a47417b8cc79f5089f31ed.svg";